import React from "react";
import { REACT_APP_API_URL } from "../env.js";
import {
  formatDate,
  formatTime,
  formatDateTime,
  getMeetingStatus,
  normalizeTitle,
  isSameDate,
  isFutureDate,
} from "../utils/tenderHelpers";
import styles from "./Tenders.module.css";

const TendersDesktopTable = ({ tenders, currentDate }) => {
  return (
    <div className={`table-responsive ${styles.tableContainer}`}>
      <table
        className={`table table-bordered align-middle text-center ${styles.table}`}
      >
        <thead className={styles.tableHead}>
          <tr>
            <th rowSpan="2" className={styles.th}>
              SL
            </th>
            <th rowSpan="2" className={styles.th}>
              Tender No.
            </th>
            <th rowSpan="2" className={`${styles.th} ${styles.thTitle}`}>
              Title
            </th>
            <th rowSpan="2" className={`${styles.th} ${styles.thDateTime}`}>
              Closing Date & Time
            </th>
            <th rowSpan="2" className={`${styles.th} ${styles.thDateTime}`}>
              Opening Date & Time
            </th>
            <th colSpan="6" className={styles.thDocuments}>
              Documents
            </th>
            <th rowSpan="2" className={styles.th}>
              Google Meet
            </th>
          </tr>
          <tr>
            <th className={`${styles.subTh} ${styles.thRfp}`}>RFP</th>
            <th className={`${styles.subTh} ${styles.thNotice}`}>Notice</th>
            <th className={`${styles.subTh} ${styles.thPrebid}`}>Pre Bid</th>
            <th className={styles.subTh}>
              Supporting
            </th>
            <th className={`${styles.subTh} ${styles.thCorrigendum}`}>
              Corrigendum/Addendum
            </th>
            <th className={`${styles.subTh} ${styles.thQuery}`}>Query</th>
          </tr>
        </thead>
        <tbody>
          {tenders.map((t, idx) => {
            const status = getMeetingStatus(t.MeetingDate, t.MeetingTime);
            return (
              <tr key={idx} className={styles.tableRow}>
                <td className={styles.td}>{idx + 1}</td>
                <td className={styles.td} style={{ whiteSpace: "nowrap" }}>
                  {t.TenderNo}
                </td>
                <td className={styles.tdTitle}>
                  {normalizeTitle(t.Title)}
                  {new Date(t.ClosingDate) > currentDate && (
                    <span className={`${styles.latestBadge} ms-2`}>New</span>
                  )}
                </td>
                <td className={styles.tdDateTime}>
                  {formatDateTime(t.ClosingDate, t.ClosingTime)}
                </td>
                <td className={styles.tdDateTime}>
                  {formatDateTime(t.OpeningDate, t.OpeningTime)}
                </td>
                <td className={styles.td}>
                  {t.RFP ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "5px",
                      }}
                    >
                      {t.RFP.split("||")
                        .filter((p) => p.trim() !== "")
                        .map((p, i) => (
                          <a
                            key={`RFP-${i}`}
                            href={`${REACT_APP_API_URL}/Tender/${p}`}
                            target="_blank"
                            rel="noreferrer"
                            className={`btn btn-sm btn-outline-primary w-100 ${styles.btnSm}`}
                          >
                            RFP {i + 1}
                          </a>
                        ))}
                    </div>
                  ) : (
                    "-"
                  )}
                </td>
                <td className={styles.td}>
                  {t.Notice ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "5px",
                      }}
                    >
                      {t.Notice.split("||")
                        .filter((p) => p.trim() !== "")
                        .map((p, i) => (
                          <a
                            key={`Notice-${i}`}
                            href={`${REACT_APP_API_URL}/Tender/${p}`}
                            target="_blank"
                            rel="noreferrer"
                            className={`btn btn-sm btn-outline-primary w-100 ${styles.btnSm}`}
                          >
                            Notice {i + 1}
                          </a>
                        ))}
                    </div>
                  ) : (
                    "-"
                  )}
                </td>
                <td className={styles.td}>
                  {t.PreBid
                    ? t.PreBid.split("||")
                      .filter((p) => p.trim() !== "")
                      .map((p, i) => (
                        <a
                          key={`PreBid-${i}`}
                          href={`${REACT_APP_API_URL}/Tender/${p}`}
                          target="_blank"
                          rel="noreferrer"
                          className={`btn btn-sm btn-outline-primary me-1 mb-1 ${styles.btnSm}`}
                        >
                          Pre Bid {i + 1}
                        </a>
                      ))
                    : "-"}
                </td>
                <td className={styles.td}>
                  {t.Supporting
                    ? t.Supporting.split("||")
                      .filter((p) => p.trim() !== "")
                      .map((p, i) => (
                        <a
                          key={`Supporting-${i}`}
                          href={`${REACT_APP_API_URL}/Tender/${p}`}
                          target="_blank"
                          rel="noreferrer"
                          className={`btn btn-sm btn-outline-primary me-1 mb-1 ${styles.btnSm}`}
                        >
                          Doc {i + 1}
                        </a>
                      ))
                    : "-"}
                </td>
                <td className={styles.td}>
                  {t.Corrigendum ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "5px",
                      }}
                    >
                      {t.Corrigendum.split("||")
                        .filter((p) => p.trim() !== "")
                        .map((p, i) => (
                          <a
                            key={`Corr-${i}`}
                            href={`${REACT_APP_API_URL}/Tender/${p}`}
                            target="_blank"
                            rel="noreferrer"
                            className={`btn btn-sm btn-outline-primary w-100 ${styles.btnSm}`}
                          >
                            Corrigendum {i + 1}
                          </a>
                        ))}
                    </div>
                  ) : (
                    "-"
                  )}
                </td>
                <td className={styles.td}>
                  {t.Query ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "5px",
                      }}
                    >
                      {t.Query.split("||")
                        .filter((p) => p.trim() !== "")
                        .map((p, i) => (
                          <a
                            key={`Query-${i}`}
                            href={`${REACT_APP_API_URL}/Tender/${p}`}
                            target="_blank"
                            rel="noreferrer"
                            className={`btn btn-sm btn-outline-primary w-100 ${styles.btnSm}`}
                          >
                            Query {i + 1}
                          </a>
                        ))}
                    </div>
                  ) : (
                    "-"
                  )}
                </td>
                <td className={styles.td}>
                  {(() => {
                    if (!t.MeetingDate || !t.MeetingTime) return "-";
                    const meetingDateObj = new Date(t.MeetingDate);
                    const today = new Date();
                    if (!isFutureDate(meetingDateObj)) return "-";
                    const status = getMeetingStatus(
                      t.MeetingDate,
                      t.MeetingTime
                    );
                    if (!isSameDate(meetingDateObj, today)) {
                      return (
                        <div className="small text-muted">
                          {formatDate(t.MeetingDate)} |{" "}
                          {formatTime(t.MeetingTime)}
                        </div>
                      );
                    }
                    if (status === "ENDED") return "-";
                    if (status === "COMING_SOON") {
                      return (
                        <div className="text-warning fw-bold">
                          Today – Coming Soon
                          <div className="small text-muted">
                            {formatDate(t.MeetingDate)} |{" "}
                            {formatTime(t.MeetingTime)}
                          </div>
                        </div>
                      );
                    }
                    return (
                      <div>
                        <a
                          href={t.MeetingLink}
                          target="_blank"
                          rel="noreferrer"
                          className={`btn btn-sm btn-success ${styles.btnSm}`}
                        >
                          Join Meeting
                        </a>
                        <div className="small text-muted mt-1">
                          {formatDate(t.MeetingDate)} |{" "}
                          {formatTime(t.MeetingTime)}
                        </div>
                      </div>
                    );
                  })()}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TendersDesktopTable;
